<template>
  <basic-card>
    <div>
      <avue-form
        ref="form"
        :option="option"
        v-model="form"
        @tab-click="handleTabClick"
        @submit="handleSubmit"
        class="global-dialog-edit"
      >
      <template #avatar="{ row }">
        <CompUploadAvatar
          @update:modelValue="(val) => form.avatar = val"
          v-model="form.avatar"
          @change="handleAvatarUpdate"
        />
      </template>

      <template #phone="{ row }">
        <CompPhone 
          :disabled="!permissionObj.edit"
          v-model="form.phone" 
          @change="handlePhoneChange"
        />
      </template>
      <!-- <template #userDateFormat="{ row }">
        <el-select v-model="form.userDateFormat" @change="handleFormatChange">
          <el-option
            v-for="(item, index) in dateFormatOptions"
            :value="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
        <div v-if="form.userDateFormat" class="preview">{{ Lang.Text.userInfoPreview }} {{ previewValue }}</div>
      </template> -->
      
      <template #menu-form>
        <div class="dialog-footer">
          <el-button v-if="index==0" @click="handleWitch" >{{ Lang.Button.userInfoDiscardChang }}</el-button>
          <el-button v-if="index==1" @click="handleEmpty">{{ Lang.Button.userInfoEmpty }}</el-button>
          <el-button type="primary" @click="handleFormSubmit">{{ Lang.Button.userInfoSaveChange }}</el-button>
        </div>
      </template>

    </avue-form>
  </div>
</basic-card>
</template>

<script>
import { getUserInfo, updateInfo, updatePassword } from '@/api/system/user';
import md5 from 'js-md5';
import func from '@/utils/func';
import { validatenull } from '@/utils/validate';
import { validateConfirmPassword } from '@/utils/validator';
import { ElMessage } from 'element-plus';
import { mapGetters } from 'vuex';
import CompPhone from '@/components/comp-phone/index';
import CompUploadAvatar from '@/components/comp-upload-avatar/index.vue';
import {
  getDeptLazyTree,
} from '@/api/system/dept';

export default {
  components: {
    CompPhone,
    CompUploadAvatar,
  },
  data() {
    return {
      dateFormatOptions: [
        {label: 'YYYY-MM-DD', value: 'YYYY-MM-DD'},
        {label: 'MM-DD-YYYY', value: 'MM-DD-YYYY'},
        {label: 'DD-MM-YYYY', value: 'DD-MM-YYYY'},
        {label: 'DD-MMM-YYYY', value: 'DD-MMM-YYYY'},
        {label: 'MMM-DD-YYYY', value: 'MMM-DD-YYYY'},
        {label: 'YYYY-MMM-DD', value: 'YYYY-MMM-DD'},
      ],
      form: {
        avatar: '',
        phone: '',
        userDateFormat: '',

      },
      previewValue: '',
      index: 0,
      option: {
        emptyBtn: false,
        submitBtn: false,

        tabs: true,
        tabsActive: 1,
        labelWidth: 140,
        labelPosition: 'top',
        group: [
          {
            label: this.Lang.label.meUserinfo,
            prop: 'info',
            column: [
              {
                label: this.Lang.label.userinfoPic,
                type: 'upload',
                listType: 'picture-img',
                propsHttp: {
                  res: 'data',
                  url: 'link',
                },
                action: '/blade-resource/oss/endpoint/put-file',
                tip: this.Lang.label.userinfoPictext,
                uploadBefore: (file,done,loading) => {
                  if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
                    ElMessage.error(this.Lang.tips.onlyCanUploadPngJpg)
                    loading();
                    return;
                  }
                  if (file.size / 1024 > 500) {
                    ElMessage.error(this.Lang.label.userinfoPictext);
                    loading();
                    return;
                  }
                  done();
                },
                span: 24,
                row: true,
                slot: true,
                prop: 'avatar',
              },
              {
                label: this.Lang.Title.userInfoName,
                span: 24,
                row: true,
                prop: 'name',
                maxlength: 100,
                placeholder: this.Lang.label.userinfoInputusername,
                rules: [{required: true, message: this.Lang.label.userinfoInputusername}]
              },
              {
                label: this.Lang.label.loginAcc,
                span: 24,
                row: true,
                prop: 'account',
                maxlength: 100,
                placeholder: this.Lang.label.userinfoInputaccname,
                rules: [{required: true,  message: this.Lang.label.userinfoInputaccname }]
              },
              {
                label: this.Lang.label.deptOf,
                prop: 'deptId',
                type: 'tree',
                span: 24,
                multiple: true,
                defaultExpandAll: true, // 回显关键
                nodeKey: 'id', // 回显关键
                dicUrl: '/blade-system/dept/lazy-tree',
                // dicUrl: '/blade-system/dept/tree',
                lazy: true,
                dataType: 'string',
                props: {
                  labelText: this.Lang.tips.title,
                  label: 'title',
                  value: 'value',
                  children: 'children',
                },
                treeLoad: function (node, resolve) {
                  const parentId = node.level === 0 ? 0 : node.data.id;
                  getDeptLazyTree(parentId).then(res => {
                    // getDeptTree({ deptId: parentId, tenantId: this.userInfo.tenant_id, roleId: this.userInfo.role_id }).then(res => {
                    resolve(
                      res.data.data.map(item => {
                        return {
                          ...item,
                          leaf: !item.hasChildren,
                        };
                      })
                    );
                  });
                },
                // checkStrictly: true,
                slot: true,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzSelectDept,
                    trigger: 'click',
                  },
                ],
              },
              {
                label: this.Lang.label.userGender,
                prop: 'sex',
                type: 'tree',
                span: 24,
                defaultExpandAll: true,
                multiple: false,
                dicUrl: '/blade-system/dict/dictionary-tree?code=sex',
                props: {
                  label: 'i18nValue',
                  value: 'dictKey',
                },
                hide: true,
              },

              {
                label: this.Lang.label.userinfoPhone,
                span: 24,
                row: true,
                prop: 'phone',
                slot: true,
                placeholder: this.Lang.label.userinfoInputphone,
              },
              {
                label: this.Lang.label.userinfoEmail,
                prop: 'email',
                span: 24,
                row: true,
                placeholder: this.Lang.label.userinfoInputmail,
              },
              // {
              //   label: this.Lang.Title.userInfoDateFormat,
              //   prop: 'userDateFormat',
              //   slot: true,
              //   type: 'select',
              //   span: 24,
              //   dicData: [
              //     {label: 'YYYY-MM-DD', value: 'YYYY-MM-DD'},
              //     {label: 'MM-DD-YYYY', value: 'MM-DD-YYYY'},
              //     {label: 'DD-MM-YYYY', value: 'DD-MM-YYYY'},
              //     {label: 'DD-MMM-YYYY', value: 'DD-MMM-YYYY'},
              //     {label: 'MMM-DD-YYYY', value: 'MMM-DD-YYYY'},
              //     {label: 'YYYY-MMM-DD', value: 'YYYY-MMM-DD'},
              //   ],
              //   hide: true,
              // },

            ],
          },
          {
            label: this.Lang.label.changePassword,
            prop: 'password',
            column: [
              {
                label: this.Lang.Title.userInfoCurrentPass,
                span: 24,
                row: true,
                type: 'password',
                prop: 'oldPassword',
                placeholder: this.Lang.tips.userinfoInputCurrentPass,
                rules: [
                  { required: false, message: this.Lang.label.userinfoInputoldpass, trigger: 'blur' },
                ],
              },
              {
                label: this.Lang.label.userinfoNewpass,
                span: 24,
                row: true,
                type: 'password',
                prop: 'newPassword',
                placeholder: this.Lang.label.userinfoInputnewpass,
                rules: [
                  { required: false, message: this.Lang.label.userinfoInputnewpass, trigger: 'blur' },
                  { min: 6, max: 20, message: this.Lang.tips.limit6to20character, trigger: 'blur' },
                ],
              },
              {
                label: this.Lang.Title.userInfoConfirmPass,
                span: 24,
                row: true,
                type: 'password',
                prop: 'newPassword1',
                placeholder: this.Lang.label.userinfoInputnewpasstx,
                rules: [
                  { required: false, message: this.Lang.label.userinfoInputcfpasstx, trigger: 'blur' },
                  // { 
                  //   validator: (rule, value, callback) => validateConfirmPassword(rule, value, callback, this.form),
                  //   trigger: 'blur'
                  // },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj[btnType+'Btn'] = true;
          if (btnType === 'delete') {
            obj.delBtn = true;
          }
        }
      }))
      console.log('个人信息页面权限', obj)
      return obj
    },
  },
  created() {
    this.handleWitch();
    const index = this.$route.query.index || 0;
    this.index = func.toInt(index, 0);
    this.option.tabsActive = this.index + 1;
    console.log('index', this.index)
  },
  mounted() {
    this.checkPermission()
  },
  methods: {
    checkPermission() {
      this.option.group[0].column.forEach(item => {
        if (['realName', 'sex', 'name', 'email', 'deptId', 'phone', 'account'].includes(item.prop)) {
          if (['account', 'deptId'].includes(item.prop)) {
            item.disabled = true;
          } else {
            item.disabled = !this.permissionObj.edit;
          }
        }
      })
    },
    handleFormatChange(format) {
      this.previewValue = this.$dayjs(new Date()).format(format);
    },
    handlePhoneChange(data) {
      console.log(data)
      this.form.phone = data.phoneNumber;
      this.form.areaCode = data.countryCode;
    },
    handleAvatarUpdate(val) {
      console.log(val)
      this.form.avatar = val;
    },
    logout() {
      this.$store.commit('SET_THEME_NAME', '');
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({ path: '/login' });
        setTimeout(() => location.reload());
      });
    },
    handleFormSubmit() {
      if (this.index == 1) {
        if (!this.form.oldPassword) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'other',
            message: this.Lang.Toast.userInfoPassCannotEmpty,
          });
          return
        }
        if (!this.form.newPassword) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'other',
            message: this.Lang.Toast.userInfoNewCannotEmprty,
          });
          return
        }
        if (!this.form.newPassword1) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'other',
            message: this.Lang.Toast.userInfoConfirmPassEmpty,
          });
          return
        }
      }
      this.$refs.form.submit()
    },
    handleEmpty() {
      this.form.oldPassword = '';
      this.form.newPassword = '';
      this.form.newPassword1 = '';
    },
    handleSubmit(form, done) {
      if (this.index === 0) {
        updateInfo(form).then(
          res => {
            if (res.data.success) {
              this.$message({
                type: 'success',
                message: this.Lang.tips.operationSuccess,
              });
              this.handleWitch()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg,
              });
            }
            done();
          },
          error => {
            window.console.log(error);
            done();
          }
        );
      } else {
        updatePassword(md5(form.oldPassword), md5(form.newPassword), md5(form.newPassword1)).then(
          res => {
            if (res.data.success) {
              this.$message({
                type: 'success',
                message: this.Lang.tips.operationSuccess,
              });
              setTimeout(() => {
                this.logout();
              }, 600);
              
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg,
              });
            }
            done();
          },
          error => {
            window.console.log(error);
            done();
          }
        );
      }
    },
    handleWitch() {
      if (this.index === 0) {
        this.form = {
          avatar: '',
          userDateFormat: '',
        }
        getUserInfo().then(res => {
          const user = res.data.data;
          this.form = {
            id: user.id,
            avatar: user.avatar,
            name: user.name,
            deptId: user.deptId,
            sex: user.sex+'',
            realName: user.realName,
            phone: user.phone,
            email: user.email,
            account: user.account,
            userDateFormat: user.userDateFormat,
          };
          if (user.userDateFormat) {
            this.handleFormatChange(user.userDateFormat)
          }
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          const userInfo = Object.assign(this.userInfo, user);
          this.$store.commit('SET_USER_INFO', userInfo);
        });
      }
    },
    handleTabClick(tabs) {
      if (validatenull(tabs.index)) {
        return;
      }
      this.index = func.toInt(tabs.index, 0);
      this.updateRules();
      this.handleWitch();
    },
    updateRules() {
      const required = this.index === 1;
      this.option.group[0].column.forEach(col => {
        if (col.prop === 'realName') {
          col.rules = [{required: !required,  message: this.Lang.label.userinfoInputaccname }];
        }
        if (col.prop === 'name') {
          col.rules = [{required: !required, message: this.Lang.label.userinfoInputusername}];
        }
      })
      this.option.group[1].column.forEach(col => {
        if (col.prop === 'oldPassword') {
          col.rules = [
            { required: required, message: this.Lang.label.userinfoInputoldpasstx, trigger: 'blur' },
          ];
        }
        if (col.prop === 'newPassword') {
          col.rules = [
            { required: required, message: this.Lang.Toast.userInfoPassSix, trigger: 'blur' },
            { min: 6, max: 20, message: this.Lang.Toast.userInfoPassSix, trigger: 'blur' },
          ];
        }
        if (col.prop === 'newPassword1') {
          col.rules = [
            { required: required, message: this.Lang.Toast.userInfoPassNotMatch, trigger: 'blur' },
            { 
              validator: required ? (rule, value, callback) => validateConfirmPassword(rule, value, callback, this.form) : null,
              trigger: 'blur'
            },
          ];
        }
      });
    }
  },
};
</script>

<style></style>
